<template>
    <div class="flex items-center justify-center py-px">
        <Avatar size="8" :user="user" text-size="text-sm" @click="toggleDetails" class="cursor-pointer hover:scale-[1.1] hover:translate-y-[-3px] duration-300"/>
        
        <!-- Invisible Overlay -->
        <BackPanel
        v-if="showDetails"
        class="!z-[998]"
        @click="closeDetails"
        ></BackPanel>

        <!-- User Details Dropdown -->
        <div
            v-if="showDetails"
            class="absolute top-[60px] right-0 bg-white shadow-lg p-[10px] rounded-md z-[9999] overflow-hidden transition-all duration-300 min-w-[20px]">
            <div class="flex items-center gap-3">
                <Avatar size="10" :user="user" text-size="text-lg"/>
                <div>
                    <p class="font-bold text-gray-800">{{ user?.firstname }} {{ user?.lastname }}</p>
                    <p class="text-sm text-gray-500">{{ user?.email }}</p>
                </div>
            </div>
            <hr class="my-2 border-gray-300" />
            <div class="flex flex-col gap-1">
                <template 
                    v-for="(item, index) in userMenuLinks"
                >
                    <router-link
                        :key="index"
                        v-if="item.route && item.route !== ''"
                        :to="item.route"
                        @click="closeDetails"
                        class="w-full text-left text-sm text-main 
                        hover:text-white font-bold py-2 px-3 rounded-md hover:bg-main
                        transition-all duration-300 block">
                        {{ item.title }}
                    </router-link>
                </template>
            </div>
            <hr class="my-2 border-gray-300" />
            <button
                class="w-full text-left text-sm text-red-500 
                hover:text-white font-bold py-2 px-3 rounded-md hover:bg-red-500
                transition-all duration-300"
                @click="logout">
                <Translate value="logout" class="w-full"/>
            </button>
        </div>
    </div>
</template>

<script>
import Avatar from "@/components/Utils/Avatar.vue";
import BackPanel from "@/components/Blocks/BackPanel.vue";

export default {
    name: 'UserIcon',
    props: {
        userMenu: {
            type: Array,
            required: false,
            default: () => []
        }
    },
    components: {
        Avatar,
        BackPanel
    },
    data() {
        return {
            user: null,
            showDetails: false
        };
    },
    computed: {
        userMenuLinks() {
            return this.$ProxyObjectFuckery(this.userMenu);
        }
    },
    mounted() {
        this.UpdateUserIcon();
    },
    watch: {
        $route() {
            this.UpdateUserIcon();
        }
    },
    methods: {
        closeDetails() {
            this.showDetails = false;
        },
        toggleDetails() {
            this.showDetails = !this.showDetails;
        },
        UpdateUserIcon() {
            this.user = this.$userStore.user;
        },
        logout() {
            this.$userStore.logout();
            this.$router.push('/login');
            this.$toast.add({
                summary: this.Translate('logged-out'),
                detail: this.Translate('logout-success'),
                severity: 'success',
                life: 3000
            });
        },
        Translate(key) {
            return this.$languageStore.getTranslation(key);
        }
    }
};
</script>
[
    {
        "id": 3,
        "route": "/profile",
        "parent": null,
        "title": "Profil",
        "View": "ProfileView",
        "icon": "Tools",
        "BasicTitle": "$page$:profile",
        "access": "$1$2$3$4$",
        "display_type": 4
    },
    {
        "id": 28,
        "route": "/firmList",
        "parent": null,
        "title": "$page$:test",
        "View": "PageView",
        "icon": "Tools",
        "BasicTitle": "$page$:test",
        "access": "$1$2$3$4$5$",
        "display_type": 4
    },
    {
        "id": 32,
        "route": "/GroupManage",
        "parent": null,
        "title": "$page$:GroupManage",
        "View": "PageView",
        "icon": "Tools",
        "BasicTitle": "$page$:GroupManage",
        "access": "$1$3$4$6$7$9$10$",
        "display_type": 4
    }
]